module.exports = __webpack_public_path__ + "141d7b086d8b14db7bc6a96826c7ce41.png";